

exports.__esModule = true;
exports.$EndRoute = undefined;

require('components/xo-models/src/checkout/index');

require('components/xo-return-to-merchant/dist/util');

var _returnParams = require('components/xo-page-components/src/returnParams');

var _squid = require('squid');

var $EndRoute = exports.$EndRoute = _squid.$ComponentRoute.extend('EndRoute', {

    path: 'end',

    trackingData: {
        fptiState: 'back_to_merchant',
        trackStateExit: true
    },

    resolve: {
        action: function action($q, $window, $util, $CheckoutAppDataModel, $CheckoutCartModel, $CheckoutSessionModel, $ReturnToMerchant, $rootScope, $populate, $MerchantPreferenceModel, $CheckoutPayeeModel, $unresolved) {

            function returnMethod(merchantPreferences) {
                if ($rootScope.wps && merchantPreferences) {
                    return merchantPreferences.returnMethod();
                } else {
                    return 'GET';
                }
            }

            function returnUrl(checkoutAppData, merchantPreferences) {
                // When "redirect_uri" is passed as a query param
                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM')) {
                    return $util.param('redirect_uri');
                }

                // WPS
                if ($rootScope.wps && merchantPreferences) {
                    return checkoutAppData.urls.return_url || merchantPreferences.returnUrl();
                }

                // By default, use return_uri from checkout session
                return checkoutAppData.urls.return_url;
            }

            function returnParams(checkoutCart, checkoutSession, checkoutAppData, returnToMerchantMethod) {

                var params = {};

                // When "redirect_uri" is passed as a query param
                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM')) {
                    params.return_uri = checkoutAppData.urls.return_url;
                    params.opType = 'payment';
                    params.token = $rootScope.token;
                }

                // Don't post PayerID for RT without purchase OR WPS
                if (!$rootScope.wps && !checkoutCart.isBillingNoPurchase()) {
                    params.PayerID = checkoutSession.payer.id;
                }

                var billingData = checkoutCart.billing;

                if (billingData && billingData.ba_token && !checkoutAppData.legacy_billing_integration) {
                    params.ba_token = billingData.ba_token;
                }

                if ($rootScope.wps) {
                    var isCartUpload = checkoutAppData.flags.is_cart_upload_flow || checkoutAppData.flags.is_shopping_cart_flow;
                    params = (0, _returnParams.$returnParams)(checkoutCart, checkoutSession, returnToMerchantMethod, 'WPS', isCartUpload);
                }

                return params;
            }

            function getMerchantPreferences(dataModel) {
                if ($rootScope.wps) {
                    return $populate(dataModel, {
                        merchantPreferences: $MerchantPreferenceModel.instance(dataModel.payee.merchant.id)
                    });
                } else {
                    return $q.when();
                }
            }

            function setMerchantCharSet(merchantPreferences, params) {
                params.charset = merchantPreferences && merchantPreferences.charSet();
            }

            var models = {};

            return $populate(models, {
                checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token),
                checkoutCart: $CheckoutCartModel.instance($rootScope.token),
                checkoutSession: $CheckoutSessionModel.instance($rootScope.token),
                payee: $CheckoutPayeeModel.instance($rootScope.token)
            }).then(function () {
                return getMerchantPreferences(models);
            }).then(function () {
                var url = returnUrl(models.checkoutAppData, models.merchantPreferences);
                var returnToMerchantMethod = returnMethod(models.merchantPreferences);
                var params = returnParams(models.checkoutCart, models.checkoutSession, models.checkoutAppData, returnToMerchantMethod);

                // check for merchant charset only for wps
                if ($rootScope.wps) {
                    setMerchantCharSet(models.merchantPreferences, params);
                }

                if (returnToMerchantMethod === 'POST') {
                    $ReturnToMerchant.postTo(url, params);
                } else {
                    // if PDT is disabled don't send params in the url
                    if (models.merchantPreferences && !models.merchantPreferences.pdtEnabled()) {
                        return $ReturnToMerchant.goTo(url);
                    }
                    $ReturnToMerchant.goTo($util.buildURL(url, params));
                }

                return $unresolved;
            });
        }
    }
});

angular.value("$EndRoute", $EndRoute);
_returnParams.$returnParams;

_squid.$ComponentRoute;

_squid.$integration;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-end/route.js
// module id = ./pages/xo-end/route.js
// module chunks = 1